import { useNavigate } from "react-router-dom";
import Home from './Home/Home';
import { HubTopNav } from '@prosolve/common-components-ui'
import LeftNav from "./LeftNav";
import useIsMobileView from '../hooks/useIsMobileView';
import useMe from "../hooks/useMe";

export default () => {
  const isMobileView = useIsMobileView();
  const navigate = useNavigate();
  const me = useMe()

  // Students are verified logins with no permissions (see jwtHelpers on the API);
  // they only pass through here on the way to /student/, so match its dark styling
  // const isStudent = Boolean(me.isVerified && !me.permissions)

  const appRootPath = ''

  return (
    <>
      <HubTopNav
        isMobileView={isMobileView}
        // THEME SELECTION DISABLED — remove isHideTheme to re-enable the theme dropdown (see src/Theme.js)
        isHideTheme={true}
        isDark={true} // to restore the old students-only dark nav: isDark={isStudent} (uncomment isStudent above)
        MobileDrawerNav={LeftNav}
        navigate={navigate}
        appRootPath={appRootPath}
        me={me}
      />
      <Home />
    </>
  )
}